import React, { useState, useEffect } from "react"
import { Row, Col, Container } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.css"
import Logo from "../../images/footer-logo.svg"
import "../../styles/home.scss"
import { useMediaQuery } from "react-responsive"
import { Link } from "gatsby"

const Footer = ({ page }) => {
  console.log("props", page)
  const [padding, setPadding] = useState("")
  let isMobile = useMediaQuery({ query: "(max-device-width: 576px)" })

  useEffect(() => {
    if (page === "Home" && isMobile) {
      setPadding("50")
    } else if (page === "Help Center" && isMobile) {
      setPadding("30")
    } else if (page === "Home" && !isMobile) {
      setPadding("30")
    } else if (page === "Help Center" && !isMobile) {
      setPadding("20")
    } else if (page === "Contact Us" && isMobile) {
      setPadding("50")
    } else {
      setPadding("10")
    }
    console.log("padding", padding)
  })

  return (
    <footer id="up-to-down" style={{ paddingTop: `${padding}%` }}>
      <Container fluid>
        <Row>
          <div className="col-md-12 text-center">
            <img src={Logo} alt="" />
          </div>
        </Row>
        <Row>
          <Col md={3} className=" connect-xs">
            <ul className="footer-menu">
              <li>Connect</li>
              <li>
                <a href="#">
                  Join our online community to learn more about addiction and
                  treatment{" "}
                </a>
                <div className="social-icon d-flex mt-3">
                  <i className="fab fa-facebook-f pr-4" aria-hidden="true"></i>
                  <i className="	fab fa-twitter" aria-hidden="true"></i>
                </div>
              </li>
            </ul>
          </Col>
        </Row>

        <hr />
        <Row className="justify-content-center ">
          <Col md={2}>
            <ul className="footer-menu">
              <li>Education Center</li>
              <li>
                <a href="#!">Addiction Hub</a>
              </li>
              <li>
                <a href="#!">Treatment Hub</a>
              </li>
              <li>
                <a href="#!">Substance Hub</a>
              </li>
              <li>
                <a href="#!">Rehab Process Hub</a>
              </li>
            </ul>
          </Col>
          <Col md={2}>
            <ul className="footer-menu">
              <Link to="/help-center">
                <li>Help Center</li>
              </Link>
              <li>
                <a href="#!">Addiction Hub</a>
              </li>
              <li>
                <a href="#!">Treatment Hub</a>
              </li>
              <li>
                <a href="#!">Substance Hub</a>
              </li>
              <li>
                <a href="#!">Rehab Process Hub</a>
              </li>
            </ul>
          </Col>
          <Col md={2}>
            <ul className="footer-menu">
              <Link to="/about-us">
                <li>About Us</li>
              </Link>
              <li>
                <Link to="/community">
                  <a>Community</a>
                </Link>
              </li>
              <li>
                <Link to="/FAQs">
                  <a>FAQ</a>
                </Link>
              </li>
              <li>
                <Link to="/contact-us">
                  <a>Contact Us</a>
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={2}>
            <ul className="footer-menu">
              <li>Legal</li>
              <li>
                <Link to="/privacy-policy">
                  <a>Privacy Policy </a>
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use">
                  <a>Terms of Use</a>
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={3} className="pr-5 connect-lg">
            <ul className="footer-menu">
              <li>Connect</li>
              <li>
                <a href="#">
                  Join our online community to learn more about addiction and
                  treatment
                </a>
                <div className="social-icon d-flex mt-3">
                  <i className="fab fa-facebook-f pr-4" aria-hidden="true"></i>
                  <i className="	fab fa-twitter" aria-hidden="true"></i>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={9} className="footer-txt-wrapper ">
            <h2>GENERAL DISCLAIMER:</h2>
            <p>
              RehabFinder.ca, in affiliation with Rehab Finder, is to be used
              for educational purposes only, is not a medical provider or
              affiliated with a provider, and does not provide medical advice in
              any shape or form. Any recommendations or suggested actions are
              for informational purposes only and are to be used at your own
              discretion without holding Rehab Finder or RehabFinder.ca
              accountable for said outcomes or said results of using such
              recommendations. <br /> Rehab Finder and RehabFinder.ca are not a
              substitute for medical advice or medical care; you should always
              consult a medical professional or group of professionals in
              relation to your particular health-related problems. All
              contributors to RehabFinder.ca or Rehab Finder, shall not be held
              liable for any loss, damage, or adverse consequence as a result of
              information provided, directly or indirectly, through Rehab Finder
              or RahbFinder.ca.
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center  footer-bottom pb-4 pr-5 ">
          <Col md={8} className="text-center footer-copyright ">
            <hr />
            Copyright © Rehabfinder.com 2019 | Disclaimer
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
